module.exports = __webpack_public_path__ + "img/schnittkante_kieferngruen_ral6028.e2f054f0.jpg";